<template>
  <div class="bg-white py-24 sm:py-32">
    <div class="mx-auto max-w-7xl px-6 lg:px-8">
      <div class="mx-auto max-w-2xl text-center">
        <h2 class="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">{{ __('Our latest blog posts') }}</h2>
        <p class="mt-2 text-lg leading-8 text-gray-600">Learn how to grow your business with our expert advice.</p>
      </div>
      <div class="mt-16 max-w-2xl lg:mx-0 lg:max-w-none">

        <carousel class="" :transition="800" :itemsToShow="3" wrap-around="true" pauseAutoplayOnHover="true" v-if="posts && posts.length >= 1">
          <slide v-for="post in posts" :key="post.id" class="flex flex-col items-start justify-between h-full p-4">
              <div class="relative w-full">
                <img :src="post.feature_image" alt="" class="aspect-[16/9] w-full rounded-2xl bg-gray-100 object-cover sm:aspect-[2/1] lg:aspect-[5/3]" />
                <div class="absolute inset-0 rounded-2xl ring-1 ring-inset ring-gray-900/10" />
              </div>
              <div class="max-w-xl text-left">
                <div class="mt-8 flex items-center gap-x-4 text-xs">
                  <time :datetime="post.published_at" class="text-gray-500">{{ date(post.published_at) }}</time>
                  <!--              <a :href="post.category.href" class="relative z-10 rounded-full bg-gray-50 px-3 py-1.5 font-medium text-gray-600 hover:bg-gray-100">{{ post.category.title }}</a>-->
                </div>
                <div class="group relative">
                  <h3 class="mt-3 text-lg font-semibold leading-6 text-gray-900 group-hover:text-gray-600">
                    <a :href="post.url">
                      <span class="absolute inset-0" />
                      {{ post.title }}
                    </a>
                  </h3>
                  <p class="mt-5 line-clamp-3 text-sm leading-6 text-gray-600" v-html="post.excerpt"/>
                </div>
                <!--            <div class="relative mt-8 flex items-center gap-x-4">-->
                <!--              <img :src="post.author.feature_image" alt="" class="h-10 w-10 rounded-full bg-gray-100" />-->
                <!--              <div class="text-sm leading-6">-->
                <!--                <p class="font-semibold text-gray-900">-->
                <!--                  <a :href="post.author.href">-->
                <!--                    <span class="absolute inset-0" />-->
                <!--                    {{ post.author.name }}-->
                <!--                  </a>-->
                <!--                </p>-->
                <!--                <p class="text-gray-600">{{ post.author.role }}</p>-->
                <!--              </div>-->
                <!--            </div>-->
              </div>
          </slide>
        </carousel>

<!--        <article v-for="post in posts" :key="post.id" class="flex flex-col items-start justify-between">-->
<!--          <div class="relative w-full">-->
<!--            <img :src="post.feature_image" alt="" class="aspect-[16/9] w-full rounded-2xl bg-gray-100 object-cover sm:aspect-[2/1] lg:aspect-[3/2]" />-->
<!--            <div class="absolute inset-0 rounded-2xl ring-1 ring-inset ring-gray-900/10" />-->
<!--          </div>-->
<!--          <div class="max-w-xl">-->
<!--            <div class="mt-8 flex items-center gap-x-4 text-xs">-->
<!--              <time :datetime="post.published_at" class="text-gray-500">{{ date(post.date) }}</time>-->
<!--&lt;!&ndash;              <a :href="post.category.href" class="relative z-10 rounded-full bg-gray-50 px-3 py-1.5 font-medium text-gray-600 hover:bg-gray-100">{{ post.category.title }}</a>&ndash;&gt;-->
<!--            </div>-->
<!--            <div class="group relative">-->
<!--              <h3 class="mt-3 text-lg font-semibold leading-6 text-gray-900 group-hover:text-gray-600">-->
<!--                <a :href="post.url">-->
<!--                  <span class="absolute inset-0" />-->
<!--                  {{ post.title }}-->
<!--                </a>-->
<!--              </h3>-->
<!--              <p class="mt-5 line-clamp-3 text-sm leading-6 text-gray-600" v-html="post.excerpt"/>-->
<!--            </div>-->
<!--&lt;!&ndash;            <div class="relative mt-8 flex items-center gap-x-4">&ndash;&gt;-->
<!--&lt;!&ndash;              <img :src="post.author.feature_image" alt="" class="h-10 w-10 rounded-full bg-gray-100" />&ndash;&gt;-->
<!--&lt;!&ndash;              <div class="text-sm leading-6">&ndash;&gt;-->
<!--&lt;!&ndash;                <p class="font-semibold text-gray-900">&ndash;&gt;-->
<!--&lt;!&ndash;                  <a :href="post.author.href">&ndash;&gt;-->
<!--&lt;!&ndash;                    <span class="absolute inset-0" />&ndash;&gt;-->
<!--&lt;!&ndash;                    {{ post.author.name }}&ndash;&gt;-->
<!--&lt;!&ndash;                  </a>&ndash;&gt;-->
<!--&lt;!&ndash;                </p>&ndash;&gt;-->
<!--&lt;!&ndash;                <p class="text-gray-600">{{ post.author.role }}</p>&ndash;&gt;-->
<!--&lt;!&ndash;              </div>&ndash;&gt;-->
<!--&lt;!&ndash;            </div>&ndash;&gt;-->
<!--          </div>-->
<!--        </article>-->
      </div>
    </div>
  </div>
</template>

<script setup>
import {Carousel, Slide} from 'vue3-carousel';
import 'vue3-carousel/dist/carousel.css';
// const posts = [
//   {
//     id: 1,
//     title: 'Boost your conversion rate',
//     href: '#',
//     description:
//         'Illo sint voluptas. Error voluptates culpa eligendi. Hic vel totam vitae illo. Non aliquid explicabo necessitatibus unde. Sed exercitationem placeat consectetur nulla deserunt vel. Iusto corrupti dicta.',
//     imageUrl:
//         'https://images.unsplash.com/photo-1496128858413-b36217c2ce36?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=3603&q=80',
//     date: 'Mar 16, 2020',
//     datetime: '2020-03-16',
//     category: { title: 'Marketing', href: '#' },
//     author: {
//       name: 'Michael Foster',
//       role: 'Co-Founder / CTO',
//       href: '#',
//       imageUrl:
//           'https://images.unsplash.com/photo-1519244703995-f4e0f30006d5?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
//     },
//   },
// ];
import {onMounted, ref} from "vue";

const posts = ref([]);

onMounted(() => {
  axios.get(route('blog-posts')).then((data) => {
    posts.value = data.data.posts.filter(post => post.feature_image !== null);
  });
});

</script>